module.exports = __webpack_public_path__ + "assets/media/artfiber.a91e6a67.mp4";